import { createService } from '@bonanza-social/toolkit/api';
import {
  InstantWheelSectorsSchema,
  InstantWheelSpinsCountSchema,
  InstantWheelRewardSchema,
} from './InstantWheelService.schemas';

export default createService(
  {
    getSectors: {
      method: 'GET',
      url: '/instantWheel',
      responseSchema: InstantWheelSectorsSchema,
    },
    getSpinsCount: {
      method: 'GET',
      url: '/wheelSpinsCount',
      responseSchema: InstantWheelSpinsCountSchema,
    },
    getReward: {
      method: 'POST',
      url: '/instantWheel',
      responseSchema: InstantWheelRewardSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
